import React, { useContext } from "react";
import Products from "./products";
import { resultsFlattener } from "./productQueries";
import { Context } from "../../context";
const Woocommerceproductsbyattribute = (props) => {
    const context = useContext(Context);
    const total = (props.attributes.rows || 1) * (props.attributes.columns || 3);
    const attributeSlugs = props.attributes.attributes.map((e) => e.attr_slug);
    const operator = props.attributes.attrOperator === "all" ? "every" : "some";
    const products = resultsFlattener(context.wc.allProducts)
        .results.filter((product) => {
        if (!product.attributes) {
            return false;
        }
        return product.attributes.nodes.some((attr) => {
            if (!attr.terms || !attr.slug || !attributeSlugs.includes(attr.slug)) {
                return false;
            }
            const terms = attr.terms.nodes.map((e) => e.databaseId);
            return props.attributes.attributes[operator]((e) => {
                return terms.includes(e.id);
            });
        });
    })
        .slice(0, total);
    return React.createElement(Products, { ...props, products: products });
};
export default Woocommerceproductsbyattribute;
